module.exports = __webpack_public_path__ + "media/images/help/company/mv-company-01-3f89b8f131b453fe619ca7c6efc4edb2.jpg";